<template>
  <nav class="navbar fixed-top navbar-dark bg-black">
    <div class="container-fluid">
      <a ref="navbarToggler"
         class="navbar-toggler my-1"
         data-bs-toggle="collapse"
         data-bs-target="#navbarNavAltMarkup"
         aria-controls="navbarNavAltMarkup"
         aria-expanded="false"
         aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </a>

      <div class="avatar-container">
        <input class="form-control my-1" v-model="searcher.search" placeholder="Szukaj samochodu..." />
      </div>
      <div class="collapse navbar-collapse" id="navbarNavAltMarkup" >
        <div class="navbar-nav">
          <router-link :to="{name: 'cars'}" class="nav-link" @click="toggleMenu">Samochody</router-link>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import search from '@/store/search';

export default {
  name: 'TopBar',
  data: () => {
    return {
      isGeolocation: true,
      statusDescription: null,
      searcher: search,
    };
  },
  methods: {
    toggleMenu() {
      this.$refs.navbarToggler.click();
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables";

nav {
  min-height: 64px;

  .navbar-toggler-icon {
    cursor: pointer;
  }

  a.active {
    color: #fff;
    border-right: 4px solid #4E006E;
  }
}
</style>